/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'one-kinds': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M658.5 63.5H369.1s100.2 3.4 100.2 95.6v705.2s6.5 87.2-100.2 95.6H655s-99.3-2.9-99.7-95.6V156.6S549 71 658.5 63.5z"/>'
  }
})
